import style from '../Home.module.scss';
import className from 'classnames/bind';
import {Image} from "../../../components";
import {numberFormat} from "../../../utils";
const cn = className.bind(style);

const CardRanks = ({name, items, cardColor, bgImage}) => {
	return (
		<div className={cn('card', 'card-ranks', cardColor)}>
			<h4 className={cn('heading')}>{name}</h4>
			<div className={cn('list-ranks')}>
				{
					items.map((item) => {
						return <div key={`card-rank-${item.id}`} className={cn('user', 'd-flex', 'gap', 'align-items')}>
							<div className={cn('medal')}><small></small></div>
							<div className={cn('avatar-rank', 'avatar')}><Image src={item.avatar} /></div>
							<div className={cn('info')}>
								<b className={cn('name')}>{item.firstname} {item.lastname}</b>
								<p className={cn('info-more')}>{item.username}</p>
								<p className={cn('revenue')}>{numberFormat(item.total)}</p>
							</div>
						</div>
					})
				}
			</div>
		</div>
	)
}

export default CardRanks